const trashFilter = {
    namespaced: true,
    state: {
        data: "0"
    },
    mutations: {
        SET_DATA(state, status) {
            state.data = status;
        }
    },
    actions: {
        setData(context, value) {
            context.commit("SET_DATA", value);
        }
    },
    getters: {
        data: state => {
            return state.data;
        },
        toParams: state => {
            return [{ column: "trash", value: state.data }];
        }
    }
};

export default trashFilter;
